import { FaStarHalfAlt } from 'react-icons/fa';
import { FaRegStar, FaStar } from 'react-icons/fa6';

const Rating = ({ value = 0, text, size = 'md', className = '' }) => {
    const ratingLabel = text ? `${value} de 5, ${text}` : `${value} de 5`;

    return (
        <div className={`rating rating--${size} ${className}`.trim()} role="img" aria-label={ratingLabel}>
            <span>
                {value >= 1 ? <FaStar /> : value >= 0.5 ? <FaStarHalfAlt /> : <FaRegStar />}
            </span>
            <span>
                {value >= 2 ? <FaStar /> : value >= 1.5 ? <FaStarHalfAlt /> : <FaRegStar />}
            </span>
            <span>
                {value >= 3 ? <FaStar /> : value >= 2.5 ? <FaStarHalfAlt /> : <FaRegStar />}
            </span>
            <span>
                {value >= 4 ? <FaStar /> : value >= 3.5 ? <FaStarHalfAlt /> : <FaRegStar />}
            </span>
            <span>
                {value >= 5 ? <FaStar /> : value >= 4.5 ? <FaStarHalfAlt /> : <FaRegStar />}
            </span>
            {text ? <span className="rating-text">{text}</span> : null}
        </div>
    );
};
export default Rating;
